define(["jquery", "gsap", "gsapScrollTrigger"], function ($, { gsap }, { ScrollTrigger }) {
    function Init(isPageEditor) {
        if (!isPageEditor) {
            gsap.registerPlugin(ScrollTrigger);
            // Selectors are like jquery selector
            setReveal(".quote--block, .gsap-reveal");

            setSlideLeft(".gsap-slide-left");
            setSlideRight(".gsap-slide-right");
            setSlideTop(".gsap-slide-top");
            setSlideBottom(".gsap-slide-bottom");

            setScrollTimeline(".timeline-container");

            setMenuAnimations(".navbar-megamenu");
            rotateImage(".gsap-rotate-image");
            setSticky(".make-sticky");
        }
    }

    function setSticky(selector) {
        window.addEventListener('resize', function () {
            $(selector).removeClass("sticky");
        });
        gsap.from($(selector), {
            scrollTrigger: {
                trigger: $(selector),
                start: "top " + $("header").height() + "px",
                end: "bottom top",
                markers: false,
                onEnter: self => {
                    $(selector).addClass("sticky");
                },
                onLeaveBack: self => {
                    $(selector).removeClass("sticky");
                },
                onRefresh: self => {
                    if (self.progress > 0) {
                        $(selector).addClass("sticky");
                    }
                }
            },
        });
    }

    function rotateImage(selector) {

        gsap.utils.toArray(selector).forEach((rotatingItem) => {
            gsap.to(rotatingItem, {
                x: 0,
                rotation: 210,
                scrollTrigger: {
                    trigger: rotatingItem,
                    start: "top center",
                    markers: false
                }
            });
        });
    }

    function setMenuAnimations(selector) {

        var scope = $(selector);

        $(".dropdown-toggle", scope).parent().on('show.bs.dropdown', function () {
            //console.log("show dropdown");
            //gsap.fromTo(".dropdown-menu", {opacity: 0 }, {opacity: 1, duration: 0.2, ease: "power1.inOut"});
            $(this).find('.dropdown-menu').first().stop(true, true).fadeIn();
        });

        $(".dropdown-toggle", scope).parent().on('shown.bs.dropdown', function () {
            //console.log("shown dropdown");
        });

        $(".dropdown-toggle", scope).parent().on('hide.bs.dropdown', function () {
            //console.log("hide dropdown");
            //gsap.fromTo(".dropdown-menu", {opacity: 1 }, {opacity: 0, duration: 0.2, ease: "power1.inOut"});
            $(this).find('.dropdown-menu').first().stop(true, true).fadeOut();
        });

        $(".dropdown-toggle", scope).parent().on('hidden.bs.dropdown', function () {
            //console.log("hidden dropdown");
        });

        $(".navbar-collapse", scope).on('show.bs.collapse', function () {
            //console.log("show collapse");
            //gsap.fromTo(this, {opacity: 0 }, {opacity: 1, duration: 1, ease: "power1.inOut"});

        });

        $(".navbar-collapse", scope).on('hide.bs.collapse', function () {
            //console.log("hide collapse");
            //gsap.fromTo(this, {opacity: 1 }, {opacity: 0, duration: 1, ease: "power1.inOut"});

        });
    }

    function setReveal(selector) {
        gsap.utils.toArray(selector).forEach((revealItem) => {
            gsap.timeline({
                scrollTrigger: { trigger: revealItem }
            }).fromTo(revealItem, {
                opacity: 0,
                scale: 0.2
            },
                {
                    opacity: 1,
                    scale: 1,
                    duration: 2,
                    ease: "power1.inOut"
                }
            );
        });
    }

    function setSlideLeft(selector) { setSlideHorizontal(selector, "-50%"); }
    function setSlideRight(selector) { setSlideHorizontal(selector, "50%"); }
    function setSlideTop(selector) {
        setSlideVertical(selector, -50);
    }
    function setSlideBottom(selector) {
        setSlideVertical(selector, 50);
    }

    function setSlideHorizontal(selector, amount) {
        gsap.utils.toArray(selector).forEach((revealItem) => {
            gsap.timeline({
                scrollTrigger: { trigger: revealItem }
            }).fromTo(revealItem, {
                opacity: 0,
                x: amount
            },
                {
                    opacity: 1,
                    x: 0,
                    duration: 2,
                    ease: "power1.inOut"
                }
            );
        });
    }

    function setSlideVertical(selector, amount) {
        var resize = 100 - Math.abs(amount);

        gsap.utils.toArray(selector).forEach((revealItem) => {
            gsap.timeline({
                scrollTrigger: { trigger: revealItem, markers: false, start: (-1 * amount) + "% bottom" }
            }).fromTo(revealItem, {
                opacity: 0,
                yPercent: amount,
                height: resize + "%",
                "margin-bottom": "1px"
            },
                {
                    opacity: 1,
                    duration: 2,
                    ease: "power1.inOut",
                    yPercent: 0,
                    height: "100%",
                    "margin-bottom": "0px"
                }
            );
        });
    }


    function setScrollTimeline(selector) {
        gsap.utils.toArray(selector).forEach((scrollItem) => {
            ScrollTrigger.create({
                trigger: scrollItem,
                //markers: true,
                start: "top center",
                end: "bottom center",
                onUpdate: self => {
                    $(".timeline", $(scrollItem)).css("height", self.progress.toFixed(3) * 100 + "%");
                }
            });
        });
    }


    return {
        Init: Init
    };
});